import { Dispatch, SetStateAction, useState } from 'react'
import { singletonHook } from 'react-singleton-hook'
import { api } from 'lib/api'
import { assertBoom } from 'lib/assertBoom'
import { run } from 'lib/run'
import { useOnce } from 'lib/useOnce'
import { UserType } from 'models/User'

let globalSetMe: Dispatch<SetStateAction<UserType | undefined>>

/**
 * Internal hook implementation for managing current user state
 * @returns {UserType | undefined} The current user or undefined if not loaded
 */
function _useMe() {
  let [me, _setMe] = useState<UserType>()

  globalSetMe = _setMe

  useOnce(() => {
    void run(async () => {
      try {
        let _me = await api.get(`/api/auth/me`)
        _setMe(_me)
      } catch (err) {
        // document.location = `/`
      }
    })
  })

  return me
}

/**
 * React hook for accessing the current authenticated user
 * @returns {UserType | undefined} The current user or undefined if not loaded
 * @description Singleton hook that fetches and caches the current user data across the app
 */
export const useMe = singletonHook(undefined, _useMe)
/**
 * Updates the global current user state
 * @param {UserType} me - The new user data
 * @throws {boom.Boom} Throws if useMe hook hasn't been initialized
 * @description Allows updating the cached user data from anywhere in the app
 */
export const setMe = (me: UserType) => {
  assertBoom(globalSetMe, `useMe not used`, `badImplementation`)
  globalSetMe(me)
}
